__webpack_require__.p = "/reports-new-job-columns/referrals-hub/";